import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// File Sources API
export const fileSourcesApi = {
  list: () => api.get('/api/file-sources/'),
  get: (id) => api.get(`/api/file-sources/${id}`),
  create: (data) => api.post('/api/file-sources/', data),
  update: (id, data) => api.put(`/api/file-sources/${id}`, data),
  delete: (id) => api.delete(`/api/file-sources/${id}`),
  uploadFile: (sourceId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/api/file-sources/${sourceId}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteFile: (sourceId, fileId) => api.delete(`/api/file-sources/${sourceId}/files/${fileId}`),
};

// Question Bases API
export const questionBasesApi = {
  list: () => api.get('/api/question-bases/'),
  get: (id) => api.get(`/api/question-bases/${id}`),
  create: (data) => api.post('/api/question-bases/', data),
  update: (id, data) => api.put(`/api/question-bases/${id}`, data),
  delete: (id) => api.delete(`/api/question-bases/${id}`),
  generateQuestions: (baseId, data) => api.post(`/api/question-bases/${baseId}/generate-questions`, data),
  listQuestions: (baseId) => api.get(`/api/question-bases/${baseId}/questions`),
  deleteAllQuestions: (baseId) => api.delete(`/api/question-bases/${baseId}/questions`),
  deleteQuestion: (baseId, questionId) => api.delete(`/api/question-bases/${baseId}/questions/${questionId}`),
  createQuestion: (baseId, data) => api.post(`/api/question-bases/${baseId}/questions`, data),
  updateQuestion: (baseId, questionId, data) => api.put(`/api/question-bases/${baseId}/questions/${questionId}`, data),
  getQuestion: (baseId, questionId) => api.get(`/api/question-bases/${baseId}/questions/${questionId}`),
  exportQuestions: (baseId, format) => {
    const url = `${API_URL}/api/question-bases/${baseId}/questions/export/${format}`;
    return url;
  },
};

// Agents API
export const agentsApi = {
  list: () => api.get('/api/agents/'),
  get: (id) => api.get(`/api/agents/${id}`),
  create: (data) => api.post('/api/agents/', data),
  update: (id, data) => api.put(`/api/agents/${id}`, data),
  delete: (id) => api.delete(`/api/agents/${id}`),
  testConnection: (id) => api.post(`/api/agents/${id}/test-connection`),
  getTestHistory: (id, testRunIds) => {
    const params = {};
    if (testRunIds && testRunIds.length > 0) {
      params.test_run_ids = testRunIds.join(',');
    }
    return api.get(`/api/agents/${id}/test-history`, { params });
  },
};

// Test Runs API
export const testRunsApi = {
  list: () => api.get('/api/test-runs/'),
  get: (id) => api.get(`/api/test-runs/${id}`),
  create: (data) => api.post('/api/test-runs/', data),
  delete: (id) => api.delete(`/api/test-runs/${id}`),
  getReport: (id) => api.get(`/api/test-runs/${id}/report`),
};

export default api;
